<div class="animated fadeIn">
  <div class="row">
    <div class="col-md-12 mb-4">
      <tabset>
        <tab heading="Slot">
          <div class="row mb-4">
            <div class="col-lg-12">
              <div class="card">
                <div class="card-header d-flex justify-content-between align-items-center" style="cursor: pointer;" (click)="isTestPanelOpen = !isTestPanelOpen">
                  <span><i class="fa fa-flask"></i> Test Slot</span>
                  <i class="fa" [class.fa-chevron-down]="!isTestPanelOpen" [class.fa-chevron-up]="isTestPanelOpen"></i>
                </div>
                <div class="card-body" *ngIf="isTestPanelOpen">
                  <div class="d-flex align-items-center gap-3 mb-3">
                    <div class="form-group mb-0">
                      <label class="me-2">Launch count</label>
                      <input class="form-control d-inline-block" style="width: 120px;" type="number" [(ngModel)]="testLaunchCount" min="1">
                    </div>
                    <button class="btn btn-sm btn-primary" type="button" [disabled]="isTestLoading" (click)="onClickTest()">
                      <span *ngIf="isTestLoading" class="spinner-border spinner-border-sm me-1"></span>
                      Run test
                    </button>
                  </div>
                  @if (testResult) {
                    <div class="row mb-3">
                      <div class="col-auto">
                        <div class="border rounded p-3 text-center">
                          <div class="text-muted small">Jackpot value</div>
                          <div class="fw-bold">{{ testResult.jackpotValue }}</div>
                        </div>
                      </div>
                      <div class="col-auto">
                        <div class="border rounded p-3 text-center">
                          <div class="text-muted small">Reward</div>
                          <div class="fw-bold text-success">{{ testResult.reward }}</div>
                        </div>
                      </div>
                      <div class="col-auto">
                        <div class="border rounded p-3 text-center">
                          <div class="text-muted small">Cost</div>
                          <div class="fw-bold text-danger">{{ testResult.cost }}</div>
                        </div>
                      </div>
                      <div class="col-auto">
                        <div class="border rounded p-3 text-center">
                          <div class="text-muted small">Balance</div>
                          <div class="fw-bold" [class.text-success]="testResult.balance >= 0" [class.text-danger]="testResult.balance < 0">{{ testResult.balance }}</div>
                        </div>
                      </div>
                    </div>
                    <table class="table table-responsive-sm table-hover table-outline mb-0">
                      <thead class="thead-light">
                        <tr>
                          <th>Rank</th>
                          <th>Count</th>
                          <th>Percent</th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (item of testResult.results; track item.rank) {
                          <tr>
                            <td>{{ item.rank }}</td>
                            <td>{{ item.count }}</td>
                            <td>{{ item.percent }}</td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  }
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12">
              <div class="card">
                <div class="card-header">
                  <i class="fa fa-sliders"></i> Slot Rewards
                </div>
                <div class="card-body">
                  <div class="mb-3">
                    <button class="btn btn-sm btn-primary" type="button" (click)="onClickAdd()">
                      <i class="fa fa-plus"></i> Add Slot Reward
                    </button>
                  </div>
                  <table class="table table-responsive-sm table-hover table-outline mb-0">
                    <thead class="thead-light">
                      <tr>
                        <th>#</th>
                        <th>Reward Rank</th>
                        <th>Multiplier</th>
                        <th>Rarity Weight</th>
                        <th>Jackpot</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (reward of slotRewards; track reward.rewardRank; let i = $index) {
                        <tr>
                          <td>{{ i + 1 }}</td>
                          <td>{{ reward.rewardRank }}</td>
                          <td>{{ reward.multiplier }}</td>
                          <td>{{ reward.rarityWeight }}</td>
                          <td>
                            @if (reward.isJackpot) {
                              <span class="badge bg-warning text-dark">Jackpot</span>
                            }
                          </td>
                          <td>
                            <button class="btn btn-sm btn-primary me-1" type="button" (click)="onClickEdit(reward)" tooltip="Edit" placement="top"><i class="fa fa-edit"></i></button>
                            <span class="text-muted mx-1">|</span>
                            <button class="btn btn-sm btn-danger" type="button" (click)="onClickDelete(reward)" tooltip="Delete" placement="top"><i class="fa fa-trash"></i></button>
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </tab>
        <tab heading="Statistics" (selectTab)="onSelectStatisticsTab()">
          <app-slot-statistics-tab #statisticsTab></app-slot-statistics-tab>
        </tab>
        <tab heading="Configurations">
          <app-configurations-block [configurations]="slotConfigurations" [collapsible]="false" />
        </tab>
      </tabset>
    </div>
  </div>
</div>

<app-slot-reward-add-modal #addModal></app-slot-reward-add-modal>
<app-slot-reward-edit-modal #editModal></app-slot-reward-edit-modal>
